import * as React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import { createMuiTheme } from '@material-ui/core/styles'
import adminTheme from '../theme/adminTheme'
import appLogo from '../assets/logo_lgs.png'

const useStyles = makeStyles({
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    background:
      'linear-gradient(160deg, #042f2e 0%, #0f766e 35%, #115e59 70%, #0f172a 100%)',
  },
  card: {
    width: '100%',
    maxWidth: 440,
    borderRadius: 24,
    border: '1px solid rgba(255,255,255,0.12)',
    boxShadow: '0 32px 64px rgba(0,0,0,0.35)',
    overflow: 'hidden',
  },
  brand: {
    textAlign: 'center',
    padding: '32px 32px 8px',
    background: 'linear-gradient(180deg, #f0fdfa 0%, #ffffff 100%)',
  },
  logo: {
    maxWidth: 150,
    marginBottom: 8,
  },
  tagline: {
    color: '#64748b',
    fontSize: 14,
  },
  header: {
    paddingBottom: 0,
  },
  content: {
    paddingTop: 8,
  },
})

const AuthPageLayout = ({ title, subtitle, children }) => {
  const classes = useStyles()

  return (
    <ThemeProvider theme={createMuiTheme(adminTheme)}>
      <Box className={classes.main}>
        <Card className={classes.card} elevation={0}>
          <Box className={classes.brand}>
            <img
              src={appLogo}
              alt="Let's Go Surveys"
              className={classes.logo}
            />
            <Typography className={classes.tagline}>Admin Panel</Typography>
          </Box>
          <CardHeader
            className={classes.header}
            title={title}
            subheader={subtitle}
            titleTypographyProps={{ variant: 'h5' }}
          />
          <CardContent className={classes.content}>{children}</CardContent>
        </Card>
      </Box>
    </ThemeProvider>
  )
}

AuthPageLayout.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default AuthPageLayout
